import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobService, Job } from '../services/job.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  constructor(private jobService: JobService) {}

  get jobs$() { return this.jobService.jobs$; }

  isActive(job: Job): boolean {
    return job.status === 'queued' || job.status === 'running';
  }

  dismiss(jobId: number): void {
    this.jobService.dismiss(jobId);
  }

  trackById(_: number, job: Job): number {
    return job.id;
  }
}
